import { Tag } from '@applyboard/crystal-ui'

type DeliveryMethodProps = Readonly<{
  deliveryMethod: string
}>

export function DeliveryMethod(props: DeliveryMethodProps) {
  return (
    <Tag intent="secondary" size="md">
      {props.deliveryMethod === 'online' ? 'Online' : 'In-Person'}
    </Tag>
  )
}
